class Popup extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.modal = null),
            (this.mask = document.querySelector(".popup-modal-mask")),
            theme.popup.enabled &&
                this.passesExpiration() &&
                (0 < theme.popup.page_content.length || theme.popup.newsletter_enabled || theme.popup.show_image_enabled || theme.popup.social_icons_enabled) &&
                setTimeout(() => {
                    1 != this.maskIsActive() && this.mask && this.fillPopupDialog();
                }, 1e3 * theme.popup.seconds_until);
    }
    storeExpiration() {
        var e = new Date(),
            t = 864e5 * theme.popup.days_until,
            o = e.setTime(e.getTime() + t);
        try {
            localStorage[theme.local_storage.popup] = JSON.stringify({ expires: o });
        } catch (e) {
            return !1;
        }
    }
    resetExpiration() {
        localStorage.removeItem(theme.local_storage.popup), this.storeExpiration();
    }
    isExpired() {
        var e = JSON.parse(localStorage[theme.local_storage.popup]).expires,
            t = new Date().getTime();
        return parseFloat(e - t) <= 0 && (this.resetExpiration(), !0);
    }
    passesExpiration() {
        let e = !1;
        try {
            theme.popup.test_mode ? (e = !0) : void 0 === localStorage[theme.local_storage.popup] ? ((e = !0), this.storeExpiration()) : (e = this.isExpired());
        } catch {
            e = !0;
        }
        return e;
    }
    maskIsActive() {
        var e = document.querySelector(".popup-modal");
        return null !== e && "none" !== e.style.display;
    }
    showMask() {
        (this.mask.style.display = "block"), document.body.classList.add("modal-on");
    }
    hideMask() {
        (this.mask.style.display = "none"), document.body.classList.remove("modal-on");
    }
    getImage() {
        var e, t;
        return !1 === theme.popup.show_image_enabled
            ? ""
            : 0 < theme.popup.image_link.length
            ? theme.utils.parseHtml(`
        <div class='popup-image'>
          <a href='${theme.popup.image_link}'>${theme.popup.show_image_url}</a>
        </div>`)
            : ((e = theme.utils.parseHtml('<div class="popup-image">')), (t = theme.utils.parseHtml(theme.popup.show_image_url)), e.appendChild(t), e);
    }
    getNewsletter() {
        var e;
        return !1 === theme.popup.newsletter_enabled ? "" : ((e = theme.utils.parseHtml("<div id='subscribe_module'></div>")).appendChild(this), e);
    }
    getSocialIcons() {
        var e = document.querySelector(".footer--social-icons");
        return !1 !== theme.popup.social_icons_enabled && e ? (e ? e.firstChild.cloneNode(!0) : void 0) : "";
    }
    getCustomClasses() {
        var e = "";
        return (
            (e += !0 === theme.popup.show_image_enabled ? " has-image" : " has-no-image") +
            (0 < theme.popup.page_content.length ? " has-page-content" : " has-no-page-content") +
            (theme.popup.newsletter_enabled ? " has-newsletter" : " has-no-newsletter") +
            (theme.popup.social_icons_enabled ? " has-social-icons" : " has-no-social-icons")
        );
    }
    getWrapper() {
        return theme.utils.parseHtml(`<dialog class='popup popup-modal ${this.getCustomClasses()}'/>`);
    }


  



async fillPopupDialog() {
    var e, t;
    (this.dialog = { body: null, image: this.getImage(), newsletter: this.getNewsletter(), social_icons: this.getSocialIcons(), wrapper: this.getWrapper() }),
        0 < theme.popup.page_content.length
            ? (e = await fetch(`/pages/${theme.popup.page_content}.json`)).ok && ((t = (await e.json())["page"]), (this.dialog.body = theme.utils.parseHtml(`<div class='page-contents'>${t.body_html}</div>`)), this.render())
            : this.render();

    // Create the new button
    const closeButton = document.getElementById("close-btn");
    closeButton.classList.add("popup-close-button");
    closeButton.innerText = "No, Continue Shopping";
    closeButton.addEventListener("click", () => this.closeDialog());


    // Open the dialog
    this.openDialog();
}




  
    getInnerContent() {
        var e;
        return (
            !(theme.popup.page_content.length < 1 && !1 === theme.popup.newsletter_enabled && !1 === theme.popup.social_icons_enabled) &&
            ((e = theme.utils.parseHtml("<div class='inner'></div>")),
            this.dialog.body && e.appendChild(this.dialog.body),
            this.dialog.newsletter && e.appendChild(this.dialog.newsletter),
            this.dialog.social_icons && e.appendChild(this.dialog.social_icons),
            e)
        );
    }
    render() {
        var e = this.getInnerContent();
        e && (this.dialog.image && this.dialog.wrapper.appendChild(this.dialog.image), this.dialog.wrapper.appendChild(e), document.body.appendChild(this.dialog.wrapper), this.openDialog());
    }
    checkContentOverflow() {
        setTimeout(() => {
            let e = !0;
            "none" === document.querySelector(".popup-modal-mask").style.display && (e = !1),
                this.modal &&
                    e &&
                    theme.utils.imagesLoaded(this.modal, () => {
                        document.querySelector("dialog[class*='popup']:last-of-type").offsetHeight >= window.innerHeight ? document.body.classList.add("modal-unfix") : document.body.classList.remove("modal-unfix");
                    });
        }, 0);
    }
    openDialog() {
        (this.modal = document.querySelector("dialog[class*='popup']")), this.eventListeners(), this.modal && (this.modal.classList.add("opened"), this.modal.classList.remove("closed")), this.checkContentOverflow(), this.showMask();
    }
    eventListeners() {
        var e = document.querySelector(".popup-modal-close");
        e && e.on("click", () => this.closeDialog()),
            this.mask.on("click", () => this.closeDialog()),
            this.modal &&
                this.modal.on("animationend", (e) => {
                    "modal-close" === e.animationName ? e.target.remove() : (e.target.classList.add("completed"), e.target.classList.remove("opened"));
                }),
            window.on("resize", () => this.checkContentOverflow()),
            document.addEventListener("keydown", (e) => {
                this.modal.classList.contains("completed") && "Escape" === e.code && this.closeDialog();
            });
    }
    closeDialog() {
        this.modal.classList.add("closed"), this.modal.classList.remove("completed"), this.modal.classList.remove("opened"), this.hideMask();
    }
}
customElements.define("popup-root", Popup);
